import { IField } from 'utils/interfaces/IField';
import InputTypes from 'utils/enums/inputTypes';

const stores: IField[] = [
    {
        presentation: 'Nome',
        label: 'Nome da Loja',
        name: 'name',
        type: InputTypes.text,
        columns: 3
    }
];

export default stores;
